import React from "react";
import { Div } from "../../../styles/Common";
import { Input } from "../../../components/Input";
import { useMediaQuery } from "react-responsive";
import { theme } from "../../../styles/theme";

export const GeneralPanel = ({ generalInfo, handleChangeGeneral }) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`,
  });

  return (
    <Div direction="column" gap="16px">
      {generalInfo?.map((ele, indx) => (
        <Input 
          key={indx}
          id={`${ele.name}`}
          label={`${ele.name}`}
          placeholder={`${ele.name}`}
          value={ele.value}
          onChange={(e) => handleChangeGeneral(e, indx)}
          disabled={isMobile}
        />
      ))}
    </Div>
  )
};